module.exports = __webpack_public_path__ + "static/media/solutions1.d043b869.png";